<template>
  <div :class="{ 'bg-custom': !nightMode, 'bg-dark': nightMode }" class="p-st">
    <div class="container py-4">
      <div
        class="text-center"
        data-aos="fade"
        data-aos-once="true"
        data-aos-duration="1000"
      >
        <span
          class="title text-center"
          :class="{ pgray: nightMode, 'text-light': nightMode }"
          >Achievements.</span
        >
      </div>
      <hr
        width="50%"
        :class="{ pgray: !nightMode, 'bg-secondary': nightMode }"
      />
      <div class="row justify-content-center">
        <div
          class="col-xl-5 col-lg-5 col-md-6 col-sm-12 py-3 px-3"
          v-for="d in data"
          :key="d.title"
          data-aos="fade-up"
          data-aos-once="true"
          data-aos-duration="800"
        >
          <div
            class="achievement-card h-100"
            :class="{ 'card-light': !nightMode, 'card-dark': nightMode }"
          >
            <div class="card-icon-wrap">
              <i class="fas fa-trophy trophy-icon"></i>
            </div>
            <div class="card-body-content">
              <p class="achievement-title" :class="{ 'text-dark-mode': nightMode }">
                {{ d.title }}
              </p>
              <div class="achievement-meta" :class="{ 'meta-dark': nightMode }">
                <span v-if="d.company">
                  <i class="fas fa-building mr-1"></i>{{ d.company }}
                </span>
                <span v-if="d.date" :class="{ 'ml-3': d.company }">
                  <i class="fas fa-calendar-alt mr-1"></i>{{ d.date }}
                </span>
                <span v-if="d.location" class="ml-3">
                  <i class="fas fa-map-marker-alt mr-1"></i>{{ d.location }}
                </span>
              </div>
              <div
                v-if="d.description"
                class="achievement-link"
                v-html="d.description"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import info from "../../info";

export default {
  name: "Achievements",
  props: {
    nightMode: {
      type: Boolean,
    },
  },
  data() {
    return {
      data: info.recommendations,
    };
  },
};
</script>

<style scoped>
.title {
  font-size: 30px;
  font-weight: 500;
}

.achievement-card {
  border-radius: 14px;
  padding: 24px 24px 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.achievement-card:hover {
  transform: translateY(-4px);
}

.card-light {
  background-color: #ffffff;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.08);
  border: 1px solid #e8e8e8;
}

.card-dark {
  background-color: #2a2f36;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.3);
  border: 1px solid #3c4148;
}

.card-icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: linear-gradient(135deg, #f6d365 0%, #fda085 100%);
  margin-bottom: 4px;
}

.trophy-icon {
  font-size: 18px;
  color: #fff;
}

.achievement-title {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
  margin: 0;
  color: #2c3e50;
}

.text-dark-mode {
  color: #f0f0f0;
}

.achievement-meta {
  font-size: 13px;
  color: #888;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.meta-dark {
  color: #aaa;
}

.achievement-meta i {
  font-size: 11px;
}

.achievement-link {
  margin-top: 4px;
  font-size: 13px;
}
</style>
